import { useNavigate } from 'react-router-dom';
import { Routes } from 'router/routes';
import ChevronRightIcon from 'components/atoms/icons/chevron-right';
import BaseButton from 'components/atoms/baseButton';
import { useReducer, type FC } from 'react';

import s from './styles.module.scss';
import ActionsButton from './actions-btn';
import { generateStatistics } from './utils';
import AuthorName from './author-name';
import AddEditCampaignForm from '../campaigns/add-edit-campaign-form';

import type { ISmsCampaignResponse } from 'infrastructure/interfaces';

const SmsCampaignDashboardItem: FC<ISmsCampaignResponse> = ({
  guid,
  name,
  statistics,
  createdBy,
  updatedBy,
  createdAt,
  updatedAt,
}) => {
  const [open, toggleOpen] = useReducer((v) => !v, false);
  const navigate = useNavigate();

  const stats = generateStatistics(statistics);

  const handleGoToDetails = () => {
    navigate(Routes.smsCampaignGuid(guid), { state: { name } });
  };

  return (
    <>
      <div className={s.wrapper}>
        <div className={s['left-side-wrapper']}>
          <div className={s['title-wrapper']}>
            <BaseButton
              type="secondary"
              icon={<ChevronRightIcon />}
              onClick={handleGoToDetails}
            />
            <h2 className={s.title}>{name}</h2>
          </div>
          <div className={s['subtitle-wrapper']}>
            <AuthorName author={createdBy} date={createdAt} isCreatedBy />
            {updatedBy && <AuthorName author={updatedBy} date={updatedAt} />}
          </div>
        </div>

        <div className={s['right-side-wrapper']}>
          <div className={s['info-wrapper']}>
            <ActionsButton onEdit={toggleOpen} />
          </div>
          <div className={s.statistics}>
            {stats.map((stat, index) => {
              return (
                <div key={index} className={s.statistic}>
                  <p className={s['statistic-label']}>{stat.label}</p>
                  <p className={s['statistic-count']}>{stat.count}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {open && (
        <AddEditCampaignForm
          open={open}
          toggleOpen={toggleOpen}
          isEditMode
          defaultValues={{ guid, name, questionKey: 'RPM Follow Up' }}
        />
      )}
    </>
  );
};
export default SmsCampaignDashboardItem;
